Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.SessionConfiguredChartListItemViewFactory
  constructor: (title, name) ->
    @title = title
    @name = name

  canHandle: (configuredCharts, session) ->
    widgetTypes = session.getWidgetCollection().map((widget) -> widget.get('type'))
    !widgetTypes.includes(@name) && configuredCharts.includes(@name)


  create: (session) ->
    new Common.Dashboard.Charts.SessionChartListItemView(@title, @name, session)
